﻿﻿export interface IProductCenterForList {
    id: number;
    centerId: number;
    productId: number;
    nextSteps: string;
    targetDate: string;
    closeDate: string;
    closedBy: string;
}
